export enum TaskBulkActionType {
    ADD_COMMENT = 'add-comment',
    CHANGE_STATUS = 'change-status',
    ATTACH_DOCUMENTS = 'attach-documents',
    DUE_DATE = 'due-date',
}
